export class RestoreInstanceImageDeviceInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "deviceName",
            "baseName": "deviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreInstanceImageDeviceInput.attributeTypeMap;
    }
    constructor() {
    }
}
